import { render, staticRenderFns } from "./CallSupportModal.vue?vue&type=template&id=5f6b5eac&"
import script from "./CallSupportModal.vue?vue&type=script&lang=ts&"
export * from "./CallSupportModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports